import { memo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

type Props = {
	mainTarget: ForNodeType<InputMaybe<string> | undefined> | undefined;
	onSetMainTarget: (input: string) => void;
};

export const QuestionPlanMainTarget = memo(({ mainTarget, onSetMainTarget }: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"メインターゲット"}
			guide="ゲストが予約する際にプランと合わせて表示される文章です。どんな人に向けたプランなのかをわかりやすく表現しましょう。"
			isEdited={mainTarget?.isEdited ?? false}
			hasError={Boolean(mainTarget?.error)}
			inputChildren={
				<InputTextField
					type="text"
					errorMessage={mainTarget?.error}
					placeholder="例) 記念日をパートナーと一緒に祝いたい人・貸切サウナでデトックスしたい人"
					value={mainTarget?.value ?? undefined}
					handleChange={onSetMainTarget}
				/>
			}
		/>
	);
});

QuestionPlanMainTarget.displayName = "QuestionPlanMainTarget";
